import { fromGeometry } from './geometry.js';
import { parseProperties } from '../generic/feature.js';
export function fromFeature(feature, header) {
    const columns = header.columns;
    const geometry = fromGeometry(feature.geometry(), header.geometryType);
    const geoJsonfeature = {
        type: 'Feature',
        geometry,
        properties: parseProperties(feature, columns),
    };
    return geoJsonfeature;
}
//# sourceMappingURL=feature.js.map